import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Container, Section, Button } from '../globalStyles';
import cosecha from '../assets/cosechaRadix.jpg';
import { Team } from '../components/Team/Team';
import { buildWhatsappUrl } from '../data/contact';
import {
	AboutContainer,
	AboutHero,
	AboutTitle,
	AboutSubtitle,
	AboutContent,
	AboutSection,
	SectionTitle,
	SectionText,
	ImageSection,
	ImageWrapper,
	AboutImage,
	ImageOverlay,
	ImageCaption,
	ValuesSection,
	ValuesGrid,
	ValueCard,
	ValueIcon,
	ValueTitle,
	ValueText,
	MissionSection,
	MissionTitle,
	MissionText,
	StatsSection,
	StatCard,
	StatNumber,
	StatLabel,
} from './AboutStyles';

export default function Quienessomos() {
	const { t } = useTranslation();
	
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.3
			}
		}
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.6 }
		}
	};

	return (
		<Section inverse={true}>
			<Container>
				<AboutContainer>
					<AboutHero>
						<AboutTitle>{t("aboutusTitle")}</AboutTitle>
						<AboutSubtitle>
							{t("aboutusSubtitle")}
						</AboutSubtitle>
					</AboutHero>

					<motion.div
						variants={containerVariants}
						initial="hidden"
						animate="visible"
					>
						<AboutContent>
							<AboutSection variants={itemVariants}>
								<SectionTitle>Nuestra Historia</SectionTitle>
								<SectionText>
									{t("aboutText")}
								</SectionText>
							</AboutSection>

							<ImageSection>
								<ImageWrapper>
									<AboutImage
										src={cosecha}
										alt="Cosecha Radixagro"
									/>
									<ImageOverlay>
										<ImageCaption>
											Trabajando con la tierra para producir semillas de excelencia
										</ImageCaption>
									</ImageOverlay>
								</ImageWrapper>
								<motion.div variants={itemVariants}>
									<SectionTitle>Nuestro Equipo</SectionTitle>
									<SectionText>
										{t("aboutText1")}
									</SectionText>
								</motion.div>
							</ImageSection>

							<MissionSection variants={itemVariants}>
								<MissionTitle>
									{t("aboutText2")}
								</MissionTitle>
								<MissionText>
									{t("aboutText3")}
								</MissionText>
							</MissionSection>

							<ValuesSection variants={itemVariants}>
								<SectionTitle>Nuestros Valores</SectionTitle>
								<ValuesGrid>
									<ValueCard
										whileHover={{ scale: 1.05 }}
										transition={{ duration: 0.3 }}
									>
										<ValueIcon>🤝</ValueIcon>
										<ValueTitle>Relaciones Duraderas</ValueTitle>
										<ValueText>
											{t("aboutText6")}
										</ValueText>
									</ValueCard>
									
									<ValueCard
										whileHover={{ scale: 1.05 }}
										transition={{ duration: 0.3 }}
									>
										<ValueIcon>🌱</ValueIcon>
										<ValueTitle>Buenas Prácticas</ValueTitle>
										<ValueText>
											{t("aboutText7")}
										</ValueText>
									</ValueCard>
									
									<ValueCard
										whileHover={{ scale: 1.05 }}
										transition={{ duration: 0.3 }}
									>
										<ValueIcon>👥</ValueIcon>
										<ValueTitle>Respeto y Cordialidad</ValueTitle>
										<ValueText>
											{t("aboutText8")}
										</ValueText>
									</ValueCard>
									
									<ValueCard
										whileHover={{ scale: 1.05 }}
										transition={{ duration: 0.3 }}
									>
										<ValueIcon>💚</ValueIcon>
										<ValueTitle>Pasión por el Trabajo</ValueTitle>
										<ValueText>
											{t("aboutText9")}
										</ValueText>
									</ValueCard>
								</ValuesGrid>
							</ValuesSection>

							<AboutSection variants={itemVariants}>
								<SectionTitle>Nuestra Misión</SectionTitle>
								<SectionText>
									{t("aboutText4")}
								</SectionText>
								<SectionText>
									{t("aboutText5")}
								</SectionText>
							</AboutSection>

							<StatsSection variants={itemVariants}>
								<StatCard>
									<StatNumber>+10</StatNumber>
									<StatLabel>Años de Experiencia</StatLabel>
								</StatCard>
								<StatCard>
									<StatNumber>1000</StatNumber>
									<StatLabel>Hectáreas Propias</StatLabel>
								</StatCard>
								<StatCard>
									<StatNumber>60%</StatNumber>
									<StatLabel>Con Sistema de Riego</StatLabel>
								</StatCard>
								<StatCard>
									<StatNumber>18</StatNumber>
									<StatLabel>Pivotes de Riego</StatLabel>
								</StatCard>
							</StatsSection>
						</AboutContent>
					</motion.div>
				</AboutContainer>
			</Container>
			
			{/* Sección del Equipo */}
			<Team inverse={false} />

			{/* Cierre con llamado a la acción */}
			<Container>
				<div style={{ textAlign: 'center', padding: '1rem 0 2rem' }}>
					<SectionText style={{ maxWidth: '760px', margin: '0 auto 1.5rem' }}>
						¿Querés conocer más sobre cómo trabajamos o sumar a Radixagro a tu próxima
						campaña? Escribinos por WhatsApp y te respondemos al instante.
					</SectionText>
					<a
						href={buildWhatsappUrl('Hola Radixagro, quiero conocer más sobre cómo trabajan.')}
						target="_blank"
						rel="noreferrer"
						style={{ textDecoration: 'none' }}
					>
						<Button style={{ color: '#066a67', borderColor: '#066a67' }}>
							Hablar por WhatsApp
						</Button>
					</a>
				</div>
			</Container>
		</Section>
	);
}
